import React from 'react';
import suspend from '../../../assets/suspendAction.png'
import remove from '../../../assets/RemoveAction.png'
import { useDispatch, useSelector } from 'react-redux';
import { updateTeam } from '../../services/operations/teamAPI';

const ActionPopup = ({setPage,selectedAction,action,desc,onClose,listTeam}) => {

  const dispatch=useDispatch()
  const token=useSelector((state)=>state.auth.token)
 
  const getButtonText = () => {
    switch (action) {
      case "Admin":
        return "Admin";
      case "Remove":
        return "Remove";
      case "Suspend":
        return "Suspend";
      default:
        return "Confirm";
    }
  };
  const getActionImage = () => {
    switch (action) {
      case "Remove":
        return remove;
      case "Suspend":
        return suspend;
      default:
        return suspend;
    }
  };

  const getPayload = () => {
    switch (action) {
      case "Admin":
        return {
          status: "",
          roles:["business-admin"] 
        };
        case "Remove":
          return {
            status: "removed",
            roles: selectedAction?.role?.length > 0 
              ? selectedAction.role.map(role => role) 
              : []
          };
          case "Suspend":
            return {
              status: "suspended",
              roles: selectedAction?.role?.length > 0 
                ? selectedAction.role.map(role => role) 
                : []
            };
            case "Revoke":
      return {
        status: "active",
        roles: selectedAction?.role?.length > 0 
          ? selectedAction.role.map(role => role) 
          : []
      };
      default:
        return {
          status: "active",
          roles: []
        };
    }
  };

  const handleStatus=async()=>{

    const payload = getPayload();

   await dispatch(updateTeam(payload,token,selectedAction.id,onClose));
   setPage(1)
   listTeam(1, null);
  
   

  }

  return (
    <div className="popup-overlay">
      <div className="popup-content" style={{width:"585px",height:"285px",display:"flex",alignItems:"center",flexDirection:"column",gap:"15px"}}>
        <img src={getActionImage()} alt='action'/>
        <h2>{action === "Admin" ? "Make Admin" : `${action} member`}</h2>
        <p style={{color:"rgba(0, 0, 0, 0.5)",textAlign:"center"}}>{desc}</p>
        <div className="popup-action-button">
          <button className="cancel-btn-action" onClick={onClose}>Cancel</button>
          <button className="confirm-btn-action" onClick={handleStatus}>{getButtonText()}</button>
        </div>
      </div>
    </div>
  );
};

export default ActionPopup;
